import PropTypes from 'prop-types';
import React from 'react';
import _ from "lodash";
import { translate as t } from '../../lib/I18n';

import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';

import Icon from './Icon';
import BaseModal from '../general/BaseModal';
import FormattedHTMLMessage from "./FormattedHTMLMessage";

const icons = {
    info: 'info',
    success: 'selected',
    warning: 'error'
};

function InfoModal ({ type, heading, title, message, onClose, hideClose, disableEscape, disableBlur, disableBorderFooter, disableHeader, disableFooter, customIcon }) {
    const icon = icons[type];
    const headerDisableProp = disableHeader ? { header: false } : null;
    const footerDisablerProp = disableFooter ? { footer: false } : null;

    const handeCloseButton = () => {
        if (onClose) {
            _.defer(onClose);
        }
        _.defer(() => {
            ModalActions.close(GlobalModals.INFO);
        });
    };

    return (
        <BaseModal
            onClose={ handeCloseButton }
            hideContinue
            hideClose={ hideClose }
            disableEscape={ disableEscape }
            disableBlur={ disableBlur }
            disableBorderFooter={ disableBorderFooter }
            className="modal--sm"
            titleText={ heading }
            { ...headerDisableProp }
            { ...footerDisablerProp }>
                <section>
                    <div className="confirmation text-center">
                        { customIcon
                            ? customIcon
                            : icon && <Icon icon={ `${icon} margin-top margin-bottom otrl-xl` } /> }


                        <p className="text-secondary text-weight--normal">
                            { t(title) }
                        </p>

                        { message && <p><FormattedHTMLMessage message={ t(message) } /></p> }
                    </div>
                </section>
        </BaseModal>
    );
}


InfoModal.propTypes = {
    title: PropTypes.string.isRequired,
    customIcon: PropTypes.any,
    message: PropTypes.string,
    onClose: PropTypes.func,
    hideClose: PropTypes.bool,
    disableEscape: PropTypes.bool,
    disableBlur: PropTypes.bool,
    disableBorderFooter: PropTypes.bool,
    disableFooter: PropTypes.bool,
    disableHeader: PropTypes.bool,
    heading: PropTypes.string,
    type: PropTypes.string,
};

InfoModal.defaultProps = {
    customIcon: null,
    disableFooter: false,
    disableBorderFooter: false,
    disableHeader: false,
    heading: 'info.title',
    type: 'success'
};


export default InfoModal;



// WEBPACK FOOTER //
// ./src/components/general/InfoModal.js